import React from 'react';
import PropTypes from 'prop-types';

import NukaCarousel from 'components/external/NukaCarousel';

const WrappedCarousel = ({ carouselRef, ...props }) => (
  <NukaCarousel ref={carouselRef} {...props} />
);

WrappedCarousel.propTypes = {
  carouselRef: PropTypes.oneOfType([
    PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default WrappedCarousel;
